import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { buildUrl } from '@utils/url/url.util';
import { Observable } from 'rxjs';
import { RESTServerRoute } from '../../types/Server';
import { ActionResponse, AssetDataResult, AssetInErrorDataResult } from '../../types/DataResult';

@Injectable()
export class AssetsApiService {
  public constructor(private readonly httpClient: HttpClient) {}

  public getAssets(params: {
    Limit?: number;
    Search?: string;
    Skip?: number;
    OnlyRecordCount?: boolean;
    WithSite?: boolean;
    WithSiteArea?: boolean;
    DynamicOnly?: boolean;
    Issuer?: boolean;
    SiteAreaID?: string[];
    SiteID?: string[];
    AssetID?: string;
  }): Observable<AssetDataResult> {
    return this.httpClient.get<AssetDataResult>(RESTServerRoute.REST_ASSETS, { params });
  }

  public getAssetsInError(params: {
    Limit?: number;
    Search?: string;
    Skip?: number;
    OnlyRecordCount?: boolean;
    WithSite?: boolean;
    WithSiteArea?: boolean;
    Issuer?: boolean;
    SiteAreaID?: string[];
    SiteID?: string[];
    ErrorType?: string[];
  }): Observable<AssetInErrorDataResult> {
    return this.httpClient.get<AssetInErrorDataResult>(RESTServerRoute.REST_ASSETS_IN_ERROR, { params });
  }

  public deleteAsset(id: string): Observable<ActionResponse> {
    return this.httpClient.delete<ActionResponse>(buildUrl(RESTServerRoute.REST_ASSET, { id }));
  }

  public tableRetrieveAssetConsumptionAction(assetId: string): Observable<ActionResponse> {
    return this.httpClient.get<ActionResponse>(
      buildUrl(RESTServerRoute.REST_ASSET_RETRIEVE_CONSUMPTION, { id: assetId }),
    );
  }
}
